module.exports = __webpack_public_path__ + "img/rain.35d9c747.png";